import { Text } from "@chakra-ui/react";
import { Flex } from "@chakra-ui/layout";

import TimelineLogs from "components/TimelineLogs";
import { EmailHistoricoLog } from "core/features/relatorios/typings";

interface HistoricoProps {
  logs: EmailHistoricoLog[];
}

function Historico({ logs }: HistoricoProps) {
  return (
    <Flex flexDir="column">
      <Text fontSize={20} mb={1}>
        Histórico
      </Text>
      {logs.map((log, index) => (
        <TimelineLogs data={log} key={index} />
      ))}
    </Flex>
  );
}

export default Historico;
